module.exports = __webpack_public_path__ + "img/profile_bg.8f08212e.png";